/**
 * 通用工具类
 */
import { Message, MessageBox } from 'element-ui'
import { delSession } from '@/api/common'
import store from '@/store'

const _Message = Message

/**
 * 弹出普通消息
 * @param {String} msg 消息内容
 * @param {Number} duration 自动消失时间，单位ms，默认2000ms
 */
export function info(msg, duration = 2000) {
  _Message({
    type: 'info',
    message: msg,
    duration,
  })
}
/**
 * 弹出警告消息
 * @param {String} msg 消息内容
 * @param {Number} duration 自动消失时间，单位ms，默认2000ms
 */
export function warning(msg, duration = 2000) {
  _Message({
    type: 'warning',
    message: msg,
    duration,
  })
}

/**
 * 弹出成功消息
 * @param {String} msg 消息内容
 * @param {Number} duration 自动消失时间，单位ms，默认2000ms
 */
export function success(msg, duration = 2000) {
  _Message({
    type: 'success',
    message: msg,
    duration,
  })
}

/**
 * 弹出错误消息
 * @param {String} msg 消息内容
 * @param {Number} duration 自动消失时间，单位ms，默认2000ms
 */
export function errorMessage(msg, duration = 2000) {
  _Message({
    type: 'error',
    message: msg,
    duration,
  })
}

/**
 * 确认框,只有一个确认按钮
 * @param {*} msg 确认框消息
 * @param {*} confimHandle 点击确认后响应事件
 */
export function alertWin(msg, confimHandle) {
  MessageBox.alert(msg).then(() => {
    if (confimHandle) {
      confimHandle()
    }
  })
}

/**
 * 确认框,有确认、取消两个按钮
 * @param {*} msg 确认框消息
 * @param {*} confimHandle 点击确认后响应事件
 * @param {*} cancelHandle 点击关闭后响应事件
 */
export function confirmWin(msg, confimHandle, cancelHandle) {
  MessageBox.confirm(msg, { closeOnClickModal: false })

    .then(() => {
      if (confimHandle) {
        confimHandle()
      }
    })
    .catch(() => {
      if (cancelHandle) {
        cancelHandle()
      }
    })
}

/**
 * 深拷贝
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
  if (source == null) {
    return null
  }
  if (typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

//分割数组
export function splitArray(array, size) {
  let data = []
  if (array.length > 0) {
    for (let i = 0; i < array.length; i += size) {
      data.push(array.slice(i, i + size))
    }
  }
  return data
}
// 数组排序（降序）
export function sortData(a, b) {
  return b.userNum - a.userNum
}
// 获取菜单权限判断是否存在
export function searchMenuCode(code, path) {
  let isExist = false
  let featureCode = null
  if (path !== '/Intercom' && path !== '/realvideo' && path !== '/externalHistory' && path !== '/monitor') {
    featureCode = sessionStorage.getItem('featureCode')
    featureCode = featureCode + ',error,login,download,realvideo,Intercom,version,dmp,Login,SecretManage,sys:newexternalHistory,monitor'

    let specType = localStorage.getItem('DEVICE_SPEC_TYPE')
    // 从浏览器缓存中获取是否为超级管理用户
    let userIsAdmin = sessionStorage.getItem('isAdmin')
    let userAccount = sessionStorage.getItem('account')
    if (userIsAdmin === '1') {
      featureCode = featureCode + ',secretManage,helmet_permissions,app_upgrade'
    }
    if (specType) {
      if (specType.indexOf('0') !== -1 && userIsAdmin === '1') {
        featureCode = featureCode + ',TenantSet'
      }
      // 校验用户账号是否为admin
      if (
        (specType.indexOf('1') !== -1 && userAccount === 'admin') ||
        (specType.indexOf('2') !== -1 && userAccount === 'admin') ||
        (specType.indexOf('3') !== -1 && userAccount === 'admin')
      ) {
        featureCode = featureCode + ',qaManage,app_upgrade'
      }
    }
  } else if (path === '/Intercom') {
    featureCode = 'Intercom,login'
    delSession('access_token')
  } else if (path === '/realvideo') {
    featureCode = 'realvideo,login'
    delSession('access_token')
  } else if(path === '/externalHistory') {
    featureCode = 'externalHistory,login'
    delSession('access_token')
  } else if(path === '/monitor') {
    featureCode = 'monitor,login'
    delSession('access_token')
  }
  if (!featureCode) {
    return false
  }
  if (featureCode.indexOf(code) >= 0) {
    isExist = true
  }
  return isExist
}
export function checkMic() {
  let hasMic = false
  try {
    navigator.mediaDevices.getUserMedia({ audio: true })
    hasMic = true
  } catch (error) {
    if (error.message === 'Requested device not found') {
      console.error('您的计算机未找到麦克风设备')
    } else {
      console.error('checkMic error', error)
    }
    hasMic = false
  }
  return hasMic
}

/**
 * 下载二进制文件
 * @param {*} blobData  二级制数据
 * @param {*} type 下载文件类型
 * @param {*} filename 文件名称
 */
export function downloadBlobFile(blobData, type, filename) {
  // 2.获取请求返回的response对象中的blob 设置文件类型，这里以excel为例
  const blob = new Blob([blobData], { type })
  // 3.创建一个临时的url指向blob对象
  const url = window.URL.createObjectURL(blob)
  // 4.创建url之后可以模拟对此文件对象的一系列操作，例如：预览、下载
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  window.URL.revokeObjectURL(url) // 5.释放这个临时的对象url
}

/**
 * 下载二进制Excel文件
 * @param {*} blobData  二级制数据
 * @param {*} filename 文件名称
 */
export function downloadBlobExcel(blobData, filename) {
  downloadBlobFile(blobData, 'application/vnd.ms-excel', filename)
}

/**
 * 用户是否具有指定权限
 * @param {*} permissionCode 权限编码
 */
export function hasPermission(permissionCode) {
  let featureCode = sessionStorage.getItem('featureCode')
  return featureCode && featureCode.indexOf(permissionCode) >= 0
}

/**
 * 判断是否包含任意指定的设备类型，动态参数，可以指定任意个数
 * 示例： inlcudeDeviceSpecType(0)     inlcudeDeviceSpecType(0,1,2,3)
 * @returns {Boolean} 是否包含
 */
export function inlcudeDeviceSpecType() {
  for (let i = 0; i < arguments.length; i++) {
    // 包含任意指定设备类型
    if (store.state.deviceSpecType.includes(arguments[i])) {
      return true
    }
  }
  // 所有指定设备类型都不包含
  return false
}

/**
 * 是否为本地开发环境
 */
export const isLocalEnv = window.location.host.includes('localhost')

/**
 * 是否为SIT环境
 */
export const isSitEnv = window.location.host.includes('jlssit')

/**
 * 修改网站Favicon
 * @param newIconPath Favicon 地址
 */
export function changeFavicon(newIconPath) {
  if (!newIconPath) {
    return false;
  }
  let link = document.querySelector('link[rel="shortcut icon"]');
  if (link && link.href) {
    link.href = newIconPath;
  } else {
    const newLink = document.createElement('link');
    newLink.rel = 'shortcut icon';
    newLink.href = newIconPath;
    document.head.appendChild(newLink);
  }
}
